
import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Typography,
    Box,
    Button,
} from "@mui/material";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faWarning,
    faXmark,
    faCheck,
} from "@fortawesome/free-solid-svg-icons";

const WarningDialog = ({
    open,
    onClose,
    onConfirm,
    title = "Confirmation",
    message = "Are you sure you want to continue?",
    description = "",
    confirmText = "YES",
    cancelText = "NO",
}) => {
    const handleConfirm = () => {
        onConfirm?.();
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="xs"
            fullWidth
        >
            <DialogTitle
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                }}
            >
                <FontAwesomeIcon
                    icon={faWarning}
                    className="text-yellow-500"
                />

                <Typography
                    variant="h6"
                    fontWeight="bold"
                    className="text-yellow-400 text-sm"
                >
                    {title}
                </Typography>
            </DialogTitle>

            <DialogContent>
                <Box sx={{ mt: 1 }} className="text-xs">
                    <DialogContentText
                        sx={{
                            color: "text.primary",
                            fontSize: 14,
                        }}
                    >
                        {message}
                    </DialogContentText>

                    {description && (
                        <Typography
                            sx={{
                                mt: 2,
                                fontWeight: 500,
                                fontSize: 14,
                            }}
                            className="text-red-500 text-xs"
                        >
                            {description}
                        </Typography>
                    )}
                </Box>
            </DialogContent>

            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button
                    onClick={onClose}
                    variant="flat"
                    color="danger"
                    size="sm"
                    className="font-semibold text-sm uppercase"
                    startContent={
                        <FontAwesomeIcon
                            icon={faXmark}
                            className="font-bold"
                        />
                    }
                >
                    {cancelText}
                </Button>

                <Button
                    onClick={handleConfirm}
                    variant="flat"
                    color="success"
                    autoFocus
                    size="sm"
                    className="font-semibold text-sm uppercase"
                    startContent={
                        <FontAwesomeIcon
                            icon={faCheck}
                            className="font-bold"
                        />
                    }
                >
                    {confirmText}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default WarningDialog;

